module.exports = __webpack_public_path__ + "static/media/8.d8276452.jpg";